<p-table [value]="recapListWithTotal()" size="small">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 20%;">{{ headerName()}}</th>
      
      @for (m of months; track m.id) {
        <th style="text-align: right;width: 6%;">
          @if (showHeader()) { <span>{{ m.label }}</span> }
        </th>
      }
      
      <th style="text-align: right;width: 6%;">
        @if (showHeader()) { <span>{{ lastColName() }}</span> }
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-monthlyRecap>
    <tr>
      <td>
        <span [class.font-bold]="monthlyRecap.isBoldRow">
          {{ monthlyRecap.shortDescription | titlecase }}
        </span>
      </td>

      @for (m of months; track m.id) {
        @let val = monthlyRecap[m.key];
        <td 
          class="max-w-[80px] p-2 border-b transition-all"
          style="text-align: right;"
          [class.cursor-pointer]="val !== 0"
          [class.hover:bg-blue-50]="val !== 0"
          (click)="val !== 0 ? openDetail(m.id, monthlyRecap) : null"
        >
          <span [class.font-bold]="monthlyRecap.isBoldRow">
            {{ transformValue(val) }}
          </span>
        </td>
      }

      <td style="text-align: right;" class="max-w-[80px] p-2 border-b">
        <span [class.font-bold]="monthlyRecap.isBoldRow">
          {{ transformValue(monthlyRecap.tot) }}
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>